import { render, staticRenderFns } from "./form-password.vue?vue&type=template&id=4cf57c54&"
import script from "./form-password.vue?vue&type=script&lang=js&"
export * from "./form-password.vue?vue&type=script&lang=js&"
import style0 from "./form-password.vue?vue&type=style&index=0&id=4cf57c54&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports